const DEFAULT_SITE_ORIGIN = "https://travel.rethinkways.com";

function isLocalHostLike() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1";
}

function getBasePath() {
  const base = typeof import.meta !== "undefined" ? (import.meta.env.BASE_URL || "/") : "/";
  return base.endsWith("/") ? base : `${base}/`;
}

function getInternalHostnames() {
  const origins = [
    typeof import.meta !== "undefined" ? import.meta.env.VITE_WORDPRESS_ORIGIN : "",
    DEFAULT_SITE_ORIGIN,
    typeof window !== "undefined" ? window.location.origin : "",
  ].filter(Boolean);

  return new Set(
    origins
      .map((origin) => {
        try {
          return new URL(origin).hostname.toLowerCase();
        } catch {
          return "";
        }
      })
      .filter(Boolean)
  );
}

const INTERNAL_HOSTNAMES = getInternalHostnames();

function isSpecialUrl(raw) {
  return /^(?:mailto:|tel:|sms:|javascript:|#)/i.test(raw);
}

function buildPathWithBase(pathname) {
  const basePath = getBasePath();
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;

  if (basePath === "/" || !isLocalHostLike()) {
    return normalizedPath;
  }

  if (normalizedPath.startsWith(basePath)) {
    return normalizedPath;
  }

  return `${basePath}${normalizedPath.replace(/^\/+/, "")}`;
}

export function normalizeSiteUrl(value) {
  const raw = String(value || "").trim();
  if (!raw || isSpecialUrl(raw)) return raw;

  try {
    const baseOrigin = typeof window !== "undefined" ? window.location.origin : DEFAULT_SITE_ORIGIN;
    const parsed = new URL(raw, baseOrigin);

    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return raw;
    }

    const host = parsed.hostname.toLowerCase();
    const isInternal = INTERNAL_HOSTNAMES.has(host) || raw.startsWith("/");
    if (!isInternal) {
      return raw;
    }

    const path = buildPathWithBase(parsed.pathname);
    if (!isLocalHostLike()) {
      return `${DEFAULT_SITE_ORIGIN}${path}${parsed.search}${parsed.hash}`;
    }
    return `${path}${parsed.search}${parsed.hash}`;
  } catch {
    if (raw.startsWith("/")) {
      const path = buildPathWithBase(raw);
      return !isLocalHostLike() ? `${DEFAULT_SITE_ORIGIN}${path}` : path;
    }
    return raw;
  }
}

export function getSiteBaseUrl() {
  if (typeof window === "undefined") {
    return DEFAULT_SITE_ORIGIN.endsWith("/") ? DEFAULT_SITE_ORIGIN : `${DEFAULT_SITE_ORIGIN}/`;
  }

  const basePath = isLocalHostLike() ? getBasePath() : "/";
  return new URL(basePath, window.location.origin).toString();
}

export function toAbsoluteSiteUrl(value) {
  const normalized = normalizeSiteUrl(value);
  const raw = String(normalized || "").trim();
  if (!raw || isSpecialUrl(raw)) return raw;

  try {
    return new URL(raw, DEFAULT_SITE_ORIGIN).toString();
  } catch {
    return raw;
  }
}
